var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Loader',{staticClass:"post-page",attrs:{"value":_vm.promises.fetch}},[(_vm.item.posts)?_c('Blocks',{attrs:{"blocks":_vm.config,"custom-components":_vm.customComponents}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }